
import { createNamespacedHelpers } from 'vuex'
import { ACTION_OPEN_MODAL, ACTION_OPEN_MODAL_SIZE_GUIDE } from '../../store/actions/sidebar'

const { mapGetters: mapGettersSidebar, mapActions } = createNamespacedHelpers('sidebar')

export default {
  name: 'sgh-generic-sidebar',
  computed: {
    ...mapGettersSidebar(['isModalOpen', 'isSizeGuideOpen', 'componentName', 'targetBack']),
    isMobile() {
      return this.$mq == 'tablet'
    },
  },
  mounted() {
    this.countrySelectorHeaderListener()
  },
  methods: {
    ...mapActions({
      openModal: ACTION_OPEN_MODAL,
      openModalSizeguide: ACTION_OPEN_MODAL_SIZE_GUIDE,
    }),
    closeSidebar() {
      if (this.componentName == 'sgh-size-guide') {
        document.querySelector('#openSizesPopupBtn').removeAttribute('disabled')
        this.openModalSizeguide({
          isModalOpen: false,
          isSizeGuideOpen: false,
          componentName: 'sgh-size-guide',
        })
        if (
          this.targetBack &&
          this.targetBack !== window.location.origin + window.location.pathname
        ) {
          document.querySelector('#ajax-container').classList.remove('hide')
          document.querySelector('#ajax-container').classList.add('custom-loader')
          window.location.replace(this.targetBack)
        }
      } else {
        this.componentName == 'sgh-country-selector-list' && this.isMobile
          ? document.querySelector('.sgh-header').classList.remove('country-selector-layer')
          : null
        this.openModal({
          isModalOpen: false,
          isSizeGuideOpen: false,
          componentName: this.componentName,
        })
      }
    },
    countrySelectorHeaderListener() {
      document
        .querySelector('body')
        .addEventListener('coutrySelectorClicked', this.openCountrySidebar)
    },
    openCountrySidebar() {
      this.openModal({
        isModalOpen: true,
        isSizeGuideOpen: false,
        componentName: 'sgh-country-selector-list',
      })
    },
  },
}
